import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";
import PendingRequestInterface from "./PendingRequestsInterface";
// Define a type for the slice state

// Define the initial state using that type

const pendingRequestSlice = createSlice({
  name: "pendingRequest",

  initialState: { requests: [], pendingRequestLoader: false },
  reducers: {
    pendingRequestReducer: (
      state: any,
      action: PayloadAction<PendingRequestInterface>
    ) => {
      state.requests = action.payload;
    },
    pendingRequestLoader: (state: any, action: PayloadAction<any>) => {
      state.pendingRequestLoader = action.payload;
    },
    resetPendingRequest: (state: any) => {
      state.requests = [];
    },
  },
});

export const {
  pendingRequestReducer,
  resetPendingRequest,
  pendingRequestLoader,
} = pendingRequestSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default pendingRequestSlice.reducer;
